import {
  makeStyles,
  Menu,
  MenuItem,
  MenuProps,
  Typography,
} from '@material-ui/core';
import Button, { ButtonProps } from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import React, { useEffect, useState } from 'react';
import colors from '../../themes/main-colors';
import useStyles from './styles';
import { LinkedPerson } from '../../__generated__/pge-types';
export type PersonChangeHandler = (person: LinkedPerson) => void;
const StyledButton = ({ ...rest }: ButtonProps) => (
  <Button
    fullWidth
    aria-controls="customized-menu"
    aria-haspopup="true"
    variant="outlined"
    endIcon={<KeyboardArrowDownIcon />}
    style={{
      background: '#fff',
    }}
    {...rest}
  />
);

interface StyledMenuProps extends MenuProps {
  width: number;
}

const useStyledMenuStyles = makeStyles(() => ({
  paper: {
    width: (props: { width: number }) => props.width,
  },
}));

const StyledMenu = (props: StyledMenuProps) => {
  const classes = useStyledMenuStyles(props);
  return (
    <Menu
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      classes={classes}
      {...props}
    />
  );
};

type Props = {
  onChange: PersonChangeHandler;
  currentPerson?: LinkedPerson;
  excludePersons?: LinkedPerson[];
  personList: LinkedPerson[];
  selectLabel?: string;
  removeSelectedUser?: boolean;
};

export const PersonDropdown = (props: Props) => {
  const classes = useStyles();
  const {
    currentPerson,
    personList,
    selectLabel,
    excludePersons = [],
    onChange,
    removeSelectedUser,
  } = props;

  const defaultProfile = undefined;

  const [selectedProfile, setSelectedProfile] = useState<
    LinkedPerson | undefined
  >(currentPerson);
  const anchorEl = React.useRef<null | HTMLElement>(null);

  const [width, setWidth] = React.useState(0);

  const [open, setOpen] = React.useState(false);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setWidth(event.currentTarget.clientWidth);
    anchorEl.current = event.currentTarget;
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (!selectLabel) {
      onChange(selectedProfile!);
    }
  }, []);

  useEffect(() => {
    if (removeSelectedUser) {
      setSelectedProfile(defaultProfile);
    } else {
      setSelectedProfile(currentPerson || defaultProfile);
    }
  }, [currentPerson, removeSelectedUser]);

  const onPersonChange = (profile: LinkedPerson) => {
    setSelectedProfile(profile);
    onChange(profile);
    onClose();
  };

  return (
    <Grid
      container
      item
      direction="column"
      spacing={4}
      alignItems={'flex-start'}
      justify={'flex-start'}
    >
      <Grid container item spacing={1} direction="row">
        <Grid item container xs={12} className={classes.groupSelector}>
          <StyledButton
            onClick={handleClick}
            data-testid="payment-method-dropdown-button"
          >
            <div className={classes.selectPersonDropdown}>
              {selectLabel && (
                <Typography
                  variant={'body1'}
                  style={{ fontSize: '1rem', padding: '0.5em' }}
                >
                  {selectLabel}
                </Typography>
              )}
              {!selectLabel && selectedProfile
                ? selectedProfile.name
                : undefined}
            </div>
          </StyledButton>
        </Grid>
      </Grid>

      <StyledMenu
        data-testid="payment-method-dropdown-menu"
        width={width}
        anchorEl={anchorEl.current}
        keepMounted
        open={open}
        onClose={onClose}
      >
        {personList
          .filter(p => !excludePersons.some(ep => ep.personId === p.personId))
          .map(profile => (
            <MenuItem
              data-testid={'test-' + profile.personId}
              className={classes.paymentItemContainer}
              key={profile.personId || ''}
              selected={
                !selectLabel && selectedProfile
                  ? profile.personId === selectedProfile.personId
                  : undefined
              }
              onClick={() => onPersonChange(profile)}
              // style={{ borderBottom: `1px solid ${colors.lightGray1}` }}
              disabled={profile.verificationStatus === 'Pending'}
            >
              {profile?.name && profile?.verificationStatus === 'Pending'
                ? profile?.name + '(Pending Verification)'
                : profile?.name || ''}
              {/* <PaymentMethodItem profile={profile} /> */}
            </MenuItem>
          ))}
      </StyledMenu>
    </Grid>
  );
};

export default PersonDropdown;
